// components/Navbar.jsx
// Desktop public marketing nav — Home, About, Contact, Get Started, Sign In.
// Mirrors BottomTabBar's `publicTabs` link set (that's the mobile equivalent
// of this bar). Was referenced in App.js as <Navbar /> with no import and no
// component file anywhere in the codebase — that's the eslint
// `react/jsx-no-undef` error this file fixes.
import { Link, useLocation } from "react-router-dom";
import logo from "./logo192.png";

const links = [
  { label: "Home",        path: "/" },
  { label: "About",       path: "/about" },
  { label: "Contact",     path: "/contact" },
  { label: "Get Started", path: "/get-started" },
];

export default function Navbar() {
  const location = useLocation();
  const isActive = (path) => location.pathname === path;

  return (
    <nav style={styles.nav} className="navbar-desktop-only">
      <Link to="/" style={styles.brand}>
        <img src={logo} alt="Soil Sista" style={styles.logo} />
        <span style={styles.brandName}>Soil Sista</span>
      </Link>
      <div style={styles.links}>
        {links.map(({ label, path }) => (
          <Link
            key={path}
            to={path}
            style={{ ...styles.link, ...(isActive(path) ? styles.linkActive : {}) }}
          >
            {label}
          </Link>
        ))}
      </div>
      <Link to="/login" style={styles.signIn}>Sign In</Link>
    </nav>
  );
}

const styles = {
  nav: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0.85rem 2rem",
    background: "white",
    borderBottom: "1px solid rgba(0,0,0,0.07)",
    position: "sticky",
    top: 0,
    zIndex: 50,
  },
  brand: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
    textDecoration: "none",
  },
  logo: { height: "32px", width: "32px", objectFit: "contain" },
  brandName: {
    fontFamily: "'Playfair Display', serif",
    fontWeight: 800,
    fontSize: "1.1rem",
    color: "var(--ink-black)",
  },
  links: { display: "flex", gap: "1.75rem" },
  link: {
    textDecoration: "none",
    color: "var(--ink-black)",
    fontSize: "0.92rem",
    fontWeight: 600,
  },
  linkActive: { color: "var(--soil-green)" },
  signIn: {
    textDecoration: "none",
    background: "var(--soil-green)",
    color: "white",
    padding: "0.5rem 1.1rem",
    borderRadius: "8px",
    fontSize: "0.9rem",
    fontWeight: 600,
  },
};